/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};
if (!rtAPI.preferences) rtAPI.preferences = {};
if (!rtAPI.preferences.call) rtAPI.preferences.call = {};

//#region API endpoint wrapper

rtAPI.preferences.call.APIEndPoint = async function (command, data) {
    return await rtAPI.call.APIEndPoint('preferences', command, data);
};

//#endregion

//#region Public methods

/**
 * Get a single user preference.
 * 
 * preferenceName values (server side):
 *  - "accessibilityFontSize"
 *  - "enableDarkMode"
 *  - "theme"
 */
rtAPI.preferences.call.getPreference = async function (preferenceName) {
    return await this.APIEndPoint('get-preference', {
        preferenceName: preferenceName
    });
};

/**
 * Update a single user preference.
 * 
 * preferenceName / preferenceValue mapping:
 *  - "accessibilityFontSize" : integer
 *  - "enableDarkMode"        : boolean
 *  - "theme"                 : string
 */
rtAPI.preferences.call.updatePreference = async function (preferenceName, preferenceValue) {
    return await this.APIEndPoint('update-preference', {
        preferenceName: preferenceName,
        preferenceValue: preferenceValue
    });
};

//#endregion